
import { Project } from '@dataheroes/messages/dist/src/types'
import { useBillingStore } from '@root/src/store/stores/billing'
import Vue from 'vue'
import ChangePasswordDialog from './ChangePasswordDialog.vue'
import TariffItem from './TariffItem.vue'
import moment from 'moment'

export default Vue.extend({
    props: {
        tariffContent: {},
    },
    data: () => ({
        isChangePasswordDialog: false,
    }),
    components: { ChangePasswordDialog, TariffItem },
    computed: {
        // $route обновляет подписчиков, $router.currentRoute — нет.
        // Меню успевало прочитать пустой id и больше не перерисовывалось,
        // хотя тариф уже лежал в сторе.
        projectId(): string | null {
            return this.$route?.params?.id || null
        },
        project(): Project | null {
            if (!this.projectId) return null
            return this.$store.getters.projectById(this.projectId) || null
        },
        billingStore() {
            return useBillingStore()
        },
        currentTariffData(): any {
            const byProject = this.billingStore.currentTariff
            const tariff = this.projectId ? byProject?.[this.projectId] : null
            if (!tariff || !Object.keys(tariff).length) return null
            return tariff
        },
        previousTariffData(): any {
            const byProject = this.billingStore.previousTariff
            if (!this.projectId || !byProject) return null
            return byProject[this.projectId] || null
        },
        tariffStateResolved(): boolean {
            const byProject = this.billingStore.currentTariff
            if (!this.projectId || !byProject) return false
            return Object.prototype.hasOwnProperty.call(byProject, this.projectId)
        },
        currentTariff(): string | null {
            if (!this.projectId || (!this.currentTariffData && !this.previousTariffData)) return null
            return this.billingStore.getCurrentTariffState(this.projectId) || null
        },
        tariffPaymentIndicator(): 'warning' | 'danger' | null {
            const previousTariff = this.previousTariffData
            if (!this.currentTariffData && previousTariff) return 'danger'

            const tariffEndOfUse = this.currentTariffData?.endOfUse

            if (!tariffEndOfUse) return null

            const endOfUse = moment(tariffEndOfUse)

            if (!endOfUse.isValid()) return null

            const daysLeft = endOfUse.endOf('day').diff(moment().startOf('day'), 'days')

            if (daysLeft > 4) return null

            return daysLeft <= 1 ? 'danger' : 'warning'
        },
        actions(): any[] {
            const actionsArray = [
                {
                    text: 'Сменить пароль',
                    icon: 'mdi-lock-reset',
                    onClick: this.openChangePasswordDialog,
                    hide: String(this.user.sub).startsWith('google-oauth2'),
                    component: null,
                },
            ]
            const projectId = this.projectId
            const billingEnabled = Boolean(this.project?.billingEnabled)
            if (billingEnabled && projectId)
                try {
                    const redirectBillingCallback = () => {
                        if (!projectId) return
                        if (!this.project?.isChannelsSlots) {
                            this.$router.push(`/project/${projectId}/billing/?section=tariffs`)
                            return
                        }
                        const currentTariffData = this.billingStore.getCurrentTariff(projectId)
                        const isTrial = Boolean(currentTariffData?.isTrial)
                        if (isTrial) {
                            this.billingStore.setAddChannelContext(null)
                            this.billingStore.selectedTariffId = 'tariff2'
                            this.billingStore.selectedSubscriptionPeriod = '6'
                            this.billingStore.setPaymentModalOpened(false)
                            this.$router.push(
                                `/project/${projectId}/billing/?section=tariffs&highlighted=true&default=tariff2&period=6`
                            )
                            return
                        }
                        this.$router.push(`/project/${projectId}/billing/?section=subscriptions`)
                    }
                    if (this.currentTariffData || this.previousTariffData)
                        actionsArray.push({
                            text: `Ваш тариф (${this.currentTariff || this.previousTariffData?.name || ''})`,
                            icon: 'mdi-wallet',
                            onClick: redirectBillingCallback,
                            hide: false,
                            component: TariffItem,
                        })
                    else if (this.tariffStateResolved) {
                        actionsArray.push({
                            text: 'Выберите тариф',
                            icon: 'mdi-wallet',
                            onClick: redirectBillingCallback,
                            hide: false,
                            component: null,
                        })
                    }
                } catch (err) {
                    console.error(err)
                }

            return [...actionsArray]
        },
        user(): any {
            return this.$auth.user || {}
        },
    },
    methods: {
        logout() {
            this.$auth.logout()
        },
        openChangePasswordDialog() {
            this.isChangePasswordDialog = true
        },
        billingPageRedirect() {},
    },
})
